import { useState } from "react"

const FormTextInput = ({ placeholder, title, value = "", setValueCB, inputInner, inputInnerCB, sideSlot, loading = false, disabled = false }) => {
  const [focus, setFocus] = useState(false)

  return (
    <div className="input-wrapper">
      <div className="cc-input">
        <span className="display-block input-title">{title}</span>
        <input
          className="key-input"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => !loading && setValueCB(e.target.value)}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            setTimeout(() => {
              setFocus(false)
            }, 100)
          }}
          disabled={disabled}
        ></input>  
          {!value && <div className="input-icon" onClick={() => inputInnerCB && inputInnerCB()}>{inputInner}</div>}
          {focus && value && <div className="input-icon" onClick={() => setValueCB("")}>X</div>}        
      </div>      
      {sideSlot}
    </div>
  )
}

export default FormTextInput
